<button mat-icon-button [matMenuTriggerFor]="menu" class="global-menu-btn" aria-label="global-menu"
  [matTooltip]="'Global Menu'">
  <mat-icon
    [ngClass]="{ 'icon-color-header': utilities.isSelectClientRoute() || utilities.isOnboardingRoute()}">public</mat-icon>
</button>
<mat-menu #menu="matMenu" class="profile-menu-list">
  <button mat-menu-item (click)="createNewClient()">
    <mat-icon>domain_add</mat-icon>
    <span i18n>Register New Client</span>
  </button>
  <button mat-menu-item (click)="createNewAcquirer()">
    <mat-icon>store</mat-icon>
    <span i18n>Register New Acquirer</span>
  </button>
  <!-- <button mat-menu-item >
    <mat-icon>rocket_launch</mat-icon>
    <span i18n>Onboarding Wizard</span>
  </button> -->
</mat-menu>